import { render, staticRenderFns } from "./Activitys.vue?vue&type=template&id=e65b1666&scoped=true"
import script from "./Activitys.vue?vue&type=script&lang=js"
export * from "./Activitys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65b1666",
  null
  
)

export default component.exports